import React from 'react';
import { useRecoilState, useRecoilValue } from "recoil";

import mainStore from "src/stores/main";

import './style.scss';
import upperDataStore from 'src/stores/upperData';
import { useTranslation } from 'src/hooks/translation';

const VerificationAccount = () => {
  const t = useTranslation();
  const { verificationResponse, verificationResolver } = useRecoilValue(upperDataStore);

  if (!verificationResponse?.data) return null;

  const { data: { name, documentNumber } } = verificationResponse

  return (
    <div className="B-verification-account">
      <div className='B-verification-account-wrapper'>
        <p className="B-Verification-info">
          <i className="global-icon icon-profile B-user-icon" />
          {name || '-'}
        </p>
        <p className="B-Verification-info">
          {documentNumber && ` ${t('DNI - ')} ${documentNumber || '-'}`}
        </p>
      </div>
      <i className="global-icon icon-logout B-verification-logout" onClick={verificationResolver?.logout} />
    </div>
  );
};

export default VerificationAccount;
